import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface ToolsDetailsNCFileDocumentsProps {
  ncFileId: number | null;
}

const ToolsDetailsNCFileDocumentsComponent: FC<ToolsDetailsNCFileDocumentsProps> = ({ getToolById, updateHeaderConfig, getNCFileById, ncFileId }) => {
  const title = useTitle();

  const { ncFileDataLoading } = useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      {ncFileId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={ncFileId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileDocuments = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileDocumentsComponent);

export { ToolsDetailsNCFileDocuments };
